import React, { useContext, useState } from "react";
// import { ThemeContext } from '../../../Context/ThemeContext'
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./header.module.css";
import logo from "../../public/assets/logo-primary.svg";
import ProfileDropdown from "./ProfileDropDown";
import { Modal } from "react-bootstrap";
import cross from "../../public/assets/closeIcon.svg";
import navigationIcon from "../../public/assets/navigationIcon.svg";
import blogIcon from "../../public/assets/BlogIcon.svg";
import transactionIcon from "../../public/assets/dollarIcon.svg";
import aboutIcon from "../../public/assets/AboutUsIcon.svg";
import logoutIcon from "../../public/assets/logoutIcon.svg";
import { useMyContext } from "../../myContext";

// let navArray = [
//   { label: "Transaction", link: "/transaction-detail", image: transactionIcon },
//   { label: "About Us", link: "https://stockal.com/about", image: aboutIcon },
//   { label: "Blog", link: "https://stockal.com/blogs", image: blogIcon },
// ];
let navArray = [{ label: "Home", link: "/transaction-detail", image: transactionIcon }];

const NewHeader = ({ show }) => {
  const [navToggle, setNavToggle] = useState(false);
  const { logout, siteLogo, loadingLogo, themeColor } = useMyContext();
  let history = useNavigate();
  const location = useLocation();

  const mobileModalClose = () => {
    setNavToggle(false);
  };

  const onClickLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    logout();
    history("/login");
  };

  return (
    <div className={styles.containerNav} style={show === true ? {padding: "0px"} : {}}>
      <div className={`container ${styles.mainContainer}`}>
      <nav
        className={`navbar navbar-expand-lg navbar-light ${styles.navbar}  ${
          show ? "" : styles.topPad
        } `}
      >
        <div className={styles.navbarImage}>
          {loadingLogo ? (
            <a href="/transaction-detail">
              <img src={siteLogo} height="38px" href="#" alt="Site-Logo"></img>
            </a>
          ) : (
            <div style={{height: "38px"}}></div>
          )}
        </div>
        {show ? (
          <div className={styles.navBarTabs}>
            {navArray.map((data) => {
              return (
                <a
                  className={styles.subTab}
                  href={data.link}
                  target={data.label !== "Home" ? "_blank" : ""}
				  style={(data.label === "Home" && location.pathname === "/transaction-detail") ? {color: themeColor} : {}}
                >
                  {data.label}
                </a>
              );
            })}
            <ProfileDropdown firstName={"ishan"} lastName={"gupta"} onClickLogout={onClickLogout}/>
          </div>
        ) : (
          ""
        )}
        {show ? (
          <div className={styles.navbarButton}>
            <img
              alt="navbar-icon"
              onClick={() => setNavToggle(true)}
              data-testid="img-div"
              src={navigationIcon}
            />
          </div>
        ) : (
          ""
        )}
      </nav>

      <div>
        <Modal
          show={navToggle}
          onHide={mobileModalClose}
          className={`${styles.navModal} d-lg-none`}
        >
          <div className={styles.mobileNavbar}>
            <div
              onClick={mobileModalClose}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px",
              }}
            >
              <img src={cross} alt="nav-close" />
            </div>
            <div>
              {navArray.map((data) => {
                return (
                  <div
                    className={styles.dropdownRow}
                    style={{ paddingLeft: "19px" }}
                  >
                    <img src={data.image} alt=""></img>
                    <a
                      className={styles.subTab}
                      href={data.link}
                      alt=""
                      target={data.label !== "Transaction" ? "_blank" : ""}
                    >
                      {data.label}
                    </a>
                  </div>
                );
              })}
              <div
                className={styles.dropdownRow}
                style={{ paddingLeft: "19px" }}
              >
                <img src={logoutIcon} alt=""></img>
                <div
                  className={styles.subTab}
                  onClick={onClickLogout}
                  style={{ color: "#FA274A" }}
                >
                  Logout
                </div>
              </div>

              {/* <div className={styles.dropdownRow} style={{paddingLeft:"18.25px"}} onClick={() => {}}>
                            <p>About Us</p>
                          </div>

                          <div className={styles.dropdownRow} style={{paddingLeft:"16.75px"}} onClick={() => {}}>
                            <p>Remittance History</p>
                          </div> */}
            </div>
          </div>
          <style jsx>{`
            @media (min-width: 992px) {
              .fade.modal-backdrop {
                display: none;
              }
            }
          `}</style>
        </Modal>
      </div>
      </div>
    </div>
  );
};

export default NewHeader;
